import "/src/style.css"
import {loginClickHandler, auth} from "../googleAuth.js"
import {onAuthStateChanged} from "firebase/auth";

export function NavBarView(props){
    
    function statusCheck(p){
        if(p == props.page) return 'active';
        else return 'normal';
    } 

    return(
        <nav className="navbar">
        <div className="container-fluid">
            <div style={{float: "left"}}>
                <ul className="nav-parent">
                    <li className='nav-element' onClick = {handleHomeClickACB}><a><span className="fas fa-home fa-lg vertical-center"></span></a></li>
                    <li className='nav-element' onClick = {handlePageChangeACB}><a className={statusCheck('Houses')}>Houses</a></li>
                    <li className='nav-element' onClick = {handlePageChangeACB}><a className={statusCheck('Elixirs')}>Elixirs</a></li>
                    <li className='nav-element' onClick = {handlePageChangeACB}><a className={statusCheck('Characters')}>Characters</a></li>
                    <li className='nav-element' onClick = {handlePageChangeACB}><a className={statusCheck('Spells')}>Spells</a></li>
                </ul>
            </div>
            <div style={{float: "right"}}>
                <ul className="nav-parent">
                        <li className='nav-element' onClick={handleProfileClickACB}><a className={statusCheck('Profile')}>Profile</a></li>
                        {window.location.hash !== '/profile' && <li className='nav-element' onClick={loginClickACB} id="authButton"><a>{props.userID ? "Log Out" : "Log In"}</a></li>}
                        
                </ul>
            </div>
        </div>
        </nav>
    );

    function handleHomeClickACB(){
        window.location.hash="/"
        props.onPageChange('Main')
    }

    function handleProfileClickACB(){
        window.location.hash="/profile"
        props.onPageChange('Profile')
    }

    function handlePageChangeACB(evt){
        window.location.hash=`/search/${evt.target.innerHTML.toLowerCase()}`
        props.onPageChange(evt.target.innerHTML)
    }

    function loginClickACB(){
        loginClickHandler();
        onAuthStateChanged(auth, (user) => props.setLoginHandler(user?.uid));
    }
}